<script setup lang="ts">
</script>

<template>
  <h2><slot /></h2>
</template>

<style scoped>

</style>
